import { makeFastFuncOfGetI18n } from '@/utils/i18n';
import { DeliveryCycleType, GetProductsRegularDeliveryRequest } from 'supporter';
import { getToday, addMonth } from '@/utils/dateUtils';

export interface GridProps {
	columns: (
		{
			name: string,
			header: any,
			minWidth: number,
			align: string
			formatter?: (row: any) => any,
		}	|
		{
			name: string,
			width: number,
			header: any,
			align: string,
			formatter?: (row: any) => any,
		}
	)[],
	options: {
		rowHeaders: string[],
		columnOptions: {
			resizable: boolean,
			minWidth: number
		},
		pageSize: string;
		pageOptions: {
			perPage: number;
			page: number;
			totalCount: number;
			centerAlign: boolean;
		},
		haveExcelDownBtn: boolean;
	},
	header: {
		height: number
	}
}

const getI18n: (key: string) => string = makeFastFuncOfGetI18n('RECURRINGPAYMENTS_PRODUCT');

export const gridProps = (): GridProps => ({
	header: {
		height: 34,
	},
	columns: [
		{
			header: window.$t('COMMON_MALL'),
			name: 'mallName',
			align: 'center',
			minWidth: 93,
		},
		{
			header: getI18n('PRODUCT_NO'),
			name: 'productNo',
			width: 130,
			align: 'center',
			formatter: ({row}: any) => `
				<button 
					type="button" 
					data-mall-no=${row.mallNo} 
					data-product-no=${row.productNo}
					name="recurringPaymentProductNoBtn"
				>
					${row.productNo}
				</button>
			`
		},
		{
			header: getI18n('PRODUCT_NAME'),
			name: 'productName',
			width: 185,
			align: 'left',
		},
		{
			header: getI18n('PARTNERS'),
			name: 'partnerName',
			width: 135,
			align: 'center',
		},
		{
			header: getI18n('APPROVAL_STATUS'),
			name: 'applyStatus',
			width: 95,
			align: 'center',
			formatter: ({ row }: any) => getI18n(row.applyStatus),
		},
		{
			header: getI18n('SALE_STATUS'),
			name: 'saleStatusType',
			width: 95,
			align: 'center',
			formatter: ({ row }: any) => getI18n(row.saleStatusType),
		},
		{
			header: getI18n('SELLING_PRICE'),
			name: 'salePrice',
			width: 113,
			align: 'center',
			formatter: ({ row }: any) => row.salePrice.toLocaleString(),
		},
		{
			header: getI18n('DISCOUNT_ON_RECURRING_PAYMENTS_IMMEDIATELY'),
			name: 'discount',
			width: 140,
			align: 'center',
			formatter: ({row}: any) => {
				if (row.discount) {
					switch (row.discount.type) {
						case 'PERCENT' :
							return `${row.discount.value}%`;
						default:
							return row.discount.value.toLocaleString();
					}
				}
				return '-';
			},
		},
		{
			header: getI18n('DISCOUNT_PRICE'),
			name: 'discountedPrice',
			width: 115,
			align: 'center',
			formatter: ({ row }: any) => row.discountedPrice.toLocaleString(),
		},
		{
			header: getI18n('DELIVERY_CYCLE'),
			name: 'deliveryCycles',
			width: 115,
			align: 'center',
			formatter: ({ row }: any) => row
				.deliveryCycles
				.map((cycle: DeliveryCycleType) =>getI18n(cycle))
				.join(', '),
		},
		{
			header: getI18n('REGISTRANT_NAME'),
			name: 'registerAdminName',
			width: 115,
			align: 'center',
		},
		{
			header: window.$t('COMMON_REGISTER_YMDT'),
			name: 'registerYmdt',
			width: 115,
			align: 'center',
		},
		{
			header: getI18n('PERSON_WHO_LAST_UPDATED'),
			name: 'updateAdminName',
			width: 115,
			align: 'center',
			formatter: ({ row }: any) => Boolean(row.updateAdminName) ? row.updateAdminName : '-',
		},
		{
			header: getI18n('LAST_UPDATE_DATE'),
			name: 'updateYmdt',
			width: 115,
			align: 'center',
			formatter: ({ row }: any) => Boolean(row.updateYmdt) ? row.updateYmdt : '-',
		},
	],
	options: {
		columnOptions: {
			minWidth: 50,
			resizable: true
		},
		rowHeaders: ['checkbox'],
		pageSize: '100',
		pageOptions: {
			perPage: 100,
			page: 1,
			totalCount: 0,
			centerAlign: true
		},
		haveExcelDownBtn: false,
	}
})

export const DEFAULT_SEARCH_QUERY_OBJECT: GetProductsRegularDeliveryRequest['params'] = {
	keywordInfo: {
		type: 'PRODUCT_NAME',
	},
	registerPeriod: {
		startYmdt: addMonth(new Date(), -3),
		endYmdt: getToday(),
	},
	saleStatusTypes: ['READY','RESERVATION_ONSALE','ONSALE','FINISHED','STOP','PROHIBITION'],
	deliveryCycleInfo: {
		isAll: true,
	},
	applyStatusType: 'ALL',
	allowsFrontDisplay: 'ALL',
	hasTotalCount: true,
}